import React, { useState } from 'react';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { CancelDialog } from '../CancelDialog/CancelDialog';
import { StickyFooter } from '../../../../CommonComponents/OPL/StickyFooter/StickyFooter';
import { useRouteParams } from '../../hooks/useRouteParams';

interface Props {
  onPrevious?(): void;
  isLoading?: boolean;
  showNext?: boolean;
  nextButtonText?: string;
}

export const Footer: React.FC<Props> = ({
  onPrevious,
  isLoading,
  showNext = true,
  nextButtonText = 'Next',
}) => {
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);

  const { clientId, draftId } = useRouteParams();

  return (
    <>
      <StickyFooter>
        {onPrevious && (
          <Button
            variant="secondary"
            leftIcon="fas fa-chevron-left"
            size="large"
            onClick={onPrevious}
            mr="auto"
          >
            Previous
          </Button>
        )}

        <Button size="large" variant="subtleInactive" onClick={() => setIsCancelDialogOpen(true)}>
          Cancel
        </Button>

        {showNext && (
          <Button
            type="submit"
            rightIcon={nextButtonText === 'Next' ? 'fas fa-chevron-right' : undefined}
            size="large"
            isLoading={isLoading}
            ml={onPrevious ? '16' : 'auto'}
          >
            {nextButtonText}
          </Button>
        )}
      </StickyFooter>

      {isCancelDialogOpen && (
        <CancelDialog
          clientId={clientId}
          draftId={draftId}
          onClose={() => setIsCancelDialogOpen(false)}
        />
      )}
    </>
  );
};
